import React, { useEffect, useState, useCallback } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions/index";
import Buttons from "../../atoms/Buttons";
import "./home.scss";
import { Icons } from "../../atoms/Icons";
import LoadingSpinner from "../../atoms/Loader";
import NotFound from "../../atoms/NotFound";
import PotValue from "../../molecules/PotValue";
import TimeTravel from "../../molecules/TimeTravel";
import YourGoals from "../../molecules/YourGoals";
import Articles from "../../molecules/Articles";
import { ModalOverlay } from "../../atoms/Modal";
import RegularPayments from "../../molecules/RegularPayments";
import Carousel from "../../atoms/Carousel";
import { Link, useNavigate } from "react-router-dom";
import { DISPLAYGREETING, inUat, MEMBERTYPE } from "../../constants/constants";
import {
  calculateAge,
  calculateAgeAtDate,
  calculateDecimalAge,
  convertToISODateFormat,
} from "../../helpers/helpers";
import { YOUR_GOALS_TASK_STATUS } from "../../constants/constants";
import { RadioButton } from "../../atoms/Radio";
import { Toasts } from "../../atoms/Toasts";
import HybridMemberLink from "../../molecules/HybridMemberLink";

const Home = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { calculatePotFetching, calculatePotData, calculatePotError } =
    useSelector((state) => state.calculateEstimatedPot);
  const { memberType, investorId, accountDetailsForSavings, membershipType } =
    props.memberObj;

  const { fetching, data, error } = useSelector((state) => state.home);
  const {
    fetching: loading,
    potData,
    error: err,
  } = useSelector((state) => state.totalPotInfo);
  const {
    fetching: alertFetching,
    data: alertData,
    error: alertError,
  } = useSelector((state) => state.homeAlert);
  const { fetching: goalsFetching, data: goalsData } = useSelector(
    (state) => state.yourGoals, //eslint-disable-line
  );
  const { notificationData } = useSelector((state) => state.pushNotifications);
  const [closedBroadcast, setClosedBroadcast] = useState([]);
  const [showMessage] = useState(true); //To show a broadcast message
  const dispatch = useDispatch();
  const {
    getHomePageContent,
    getTotalPotInfo,
    getNotifications,
    homeAlertContent,
    getYourGoals,
    calculatePotValue,
    postYourGoals,
  } = bindActionCreators(
    actionCreators,
    dispatch, // eslint-disable-line
  );

  // eslint-disable-next-line
  const { fetching: postLoading, data: postData } = useSelector(
    (state) => state.yourGoalsPost, //eslint-disable-line
  );
  const [MessagesClosed, setMessagesClosed] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [popup, setPopup] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [blurCount, setBlurCount] = useState(0);
  const [estimatedValue, setEstimatedValue] = useState();
  const [count, setCount] = useState(0);

  let investorObject = null;
  if (memberType !== MEMBERTYPE.INACTIVE) {
    const activeAccounts = accountDetailsForSavings?.filter(
      (obj) => obj.active && !obj.deffered && obj.recentActive //eslint-disable-line
    );

    if (activeAccounts && activeAccounts.length > 0) {
      investorObject = activeAccounts.reduce(
        (youngest, obj) =>
          obj.retirementAge < youngest.retirementAge ? obj : youngest //eslint-disable-line
      );
    } else {
      // Only deferred accounts left
      const deferredAccounts = accountDetailsForSavings?.filter(
        (obj) => obj.deffered && obj.recentActive //eslint-disable-line
      );

      if (deferredAccounts && deferredAccounts.length > 0) {
        investorObject = deferredAccounts.reduce(
          (youngest, obj) =>
            obj.retirementAge < youngest.retirementAge ? obj : youngest //eslint-disable-line
        );
      }
    }
  }

  let totalFund = accountDetailsForSavings
    .filter((account) => !account.drawdown) //eslint-disable-line
    .reduce((sum, account) => sum + parseFloat(account.totalBalance || 0), 0);

  const navigate = useNavigate();
  const handleMouseEnter = () => {
    if (!isButtonClicked) {
      setIsHovered(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isButtonClicked) {
      setIsHovered(false);
    }
  };

  const handleAboutYourTPT = () => {
    setIsButtonClicked(true);
    setIsHovered(false);
    setBlurCount(0);
    showModal("PotsBreakDown");
  };

  const handleOnBlur = () => {
    if (blurCount == 1) {
      setIsButtonClicked(false);
    } else {
      setBlurCount(1);
    }
  };
  // prettier-ignore
  let year = null;
  let age = null;
  if (
    memberType !== MEMBERTYPE.INACTIVE &&
    investorObject?.retirementAge &&
    investorObject?.retirementDate
  ) {
    const rDate = new Date(investorObject?.retirementDate);
    const today = new Date();
    // prettier-ignore
    if (rDate < today) {
      rDate?.setFullYear(today?.getFullYear());
      age = calculateAgeAtDate(
        data?.timeTravel?.birthDate,
        convertToISODateFormat(rDate)
      );
       if (!isNaN(rDate)) {
        year = convertToISODateFormat(rDate);
      }  
    } else {
      age =
        investorObject?.retirementAge < 55 ? 55 : investorObject?.retirementAge;
      if (!isNaN(rDate)) {
      rDate.setFullYear(
        rDate?.getFullYear() + (age - investorObject?.retirementAge) //eslint-disable-line
      );
      year = convertToISODateFormat(rDate);
    }  
    }
  }
  // prettier-ignore
  const [initialRetirementYear, setInitialRetirementYear] = useState(
    new Date(investorObject && investorObject.retirementDate).getUTCFullYear()
  );

  // prettier-ignore
  const [initialpersonAge, setInitialpersonAge] = useState(
    investorObject && investorObject?.retirementAge
  );
  // prettier-ignore
  const [retirementYear, setRetirementYear] = useState(
    investorObject?.retirementAge < age
      ? new Date(year).getUTCFullYear()
      : new Date(
          investorObject && investorObject?.retirementDate
        ).getUTCFullYear()
  );
  const [personAge, setPersonAge] = useState(
    investorObject?.retirementAge < age
      ? age
      : investorObject && investorObject?.retirementAge //eslint-disable-line
  );
  useEffect(() => {
    if (investorObject?.retirementAge !== undefined && !isNaN(age)) {
      const finalAge =
        investorObject?.retirementAge < age
          ? age
          : investorObject?.retirementAge;
      const finalYear =
        investorObject?.retirementAge < age
          ? new Date(year).getUTCFullYear()
          : new Date(investorObject?.retirementDate).getUTCFullYear();
      setRetirementYear(finalYear);
      setInitialpersonAge(finalAge);
      setPersonAge(finalAge);
      setInitialRetirementYear(finalYear);
    }
  }, [investorObject, age]);
  const [initialEstimatedVal, setInitialEstimatedVal] = useState(undefined);

  // prettier-ignore
  const [estimatedVal, setEstimatedVal] = useState(
    initialEstimatedVal ? initialEstimatedVal : ""
  );

  useEffect(() => {
    setEstimatedVal(initialEstimatedVal ? initialEstimatedVal : "");
    const closedBroadcastFromStorage =
      JSON.parse(localStorage.getItem("closedBroadcast")) || [];
    setClosedBroadcast(closedBroadcastFromStorage);
  }, [data]);

  const [updatedTask, setUpdatedTask] = useState();
  const [isTaskUpdated, setIsTaskUpdated] = useState(false);
  const [selectedGoal, setSelectedGoal] = useState();
  const [showToaster, setShowToaster] = useState(false);

  const updateTask = (task) => {
    if (task.status === YOUR_GOALS_TASK_STATUS.NOT_STARTED) {
      setUpdatedTask(task);
      setShowToaster(true);
      setIsTaskUpdated(true);
      sessionStorage.setItem("showToaster", "true");
      postYourGoals(investorId, task.goalId, task.taskId);
    }
  };

  useEffect(() => {
    // Initialize the state from session storage for showing goal complete toaster
    const storedShowToaster = sessionStorage.getItem("showToaster");
    if (storedShowToaster === "true") {
      setShowToaster(true);
    }
  }, []);
  useEffect(() => {
    // filter goals which are not started
    const notStartedGoals = goalsData?.goalData?.filter(
      (item) => item.status === YOUR_GOALS_TASK_STATUS.NOT_STARTED, //eslint-disable-line
    );
    if (notStartedGoals?.length != 0) {
      setSelectedGoal(
        goalsData?.goalData?.filter(
          (item) => item.status === YOUR_GOALS_TASK_STATUS.NOT_STARTED, //eslint-disable-line
        )[0], //eslint-disable-line
      );
    } else {
      setSelectedGoal(
        goalsData?.goalData?.filter(
          (item) => item.status === YOUR_GOALS_TASK_STATUS.COMPLETED, //eslint-disable-line
        )[0], //eslint-disable-line
      );
    }
  }, [goalsData]);

  useEffect(() => {
    if (isTaskUpdated) {
      // eslint-disable-next-line
      setSelectedGoal((prevState) => {
        let tasksObject = prevState?.goalTasks?.map((item) => {
          let newTask = { ...item };
          if (item.taskId === updatedTask?.taskId) {
            newTask.status = YOUR_GOALS_TASK_STATUS.COMPLETED;
          }
          return newTask;
        });
        let newObj = {
          contentType: prevState.contentType,
          goalId: prevState.goalId,
          goalTasks: tasksObject,
          name: prevState.name,
          segment: prevState.segment,
          status: prevState.status,
        };
        return newObj;
      });
      setIsTaskUpdated(false);
    }
  }, [isTaskUpdated]);
  const handleNavigation = (item) => {
    // navigate(url); // Use navigate to programmatically navigate
    localStorage.setItem("previousPage", window.location.href);
    if (item?.target === "_blank") {
      // Open in a new tab
      window.open(item?.url, "_blank");
    } else {
      // Open in the same tab
      window.open(item?.url, "_self");
    }

    window.scroll(0, 0);
  };

  const RadioBtnComp = useCallback(() => {
    const notStartedTasks =
      selectedGoal?.goalTasks?.filter(
        (task) => task.status === YOUR_GOALS_TASK_STATUS.NOT_STARTED, //eslint-disable-line
      ) || [];
    const completedTasks =
      selectedGoal?.goalTasks?.filter(
        (task) => task.status === YOUR_GOALS_TASK_STATUS.COMPLETED, //eslint-disable-line
      ) || [];
    const combinedTasks =
      selectedGoal?.goalTasks?.length > 5
        ? [...notStartedTasks, ...completedTasks].slice(0, 5)
        : selectedGoal?.goalTasks;

    return (
      <div className="goal-section">
        {combinedTasks?.length > 0
          ? combinedTasks?.map((item, index) => (
              <a
                rel="noreferrer"
                key={index}
                onClick={(e) => {
                  e.preventDefault(); // Prevent default anchor behavior
                  handleNavigation(item); // Navigate programmatically
                }}
              >
                {" "}
                <RadioButton actualItem={item} updateTask={updateTask} />
              </a>
            ))
          : combinedTasks?.goalTasks?.map((item, index) => (
              <a
                rel="noreferrer"
                key={index}
                onClick={(e) => {
                  e.preventDefault(); // Prevent default anchor behavior
                  handleNavigation(item); // Navigate programmatically
                }}
              >
                {" "}
                <RadioButton actualItem={item} updateTask={updateTask} />
              </a>
            ))}
      </div>
    );
  }, [selectedGoal]);
  const handleSave = (object) => {
    const savedData = {
      potValue: object.potValue,
      year: parseInt(object.year),
      age: parseInt(object.age),
    };

    sessionStorage.setItem("timeTravelSavedData", JSON.stringify(savedData));

    setRetirementYear(savedData.year);
    setPersonAge(savedData.age);
    setEstimatedVal(savedData.potValue);
    setEstimatedValue(savedData.potValue);
  };

  useEffect(() => {
    const savedData = JSON.parse(sessionStorage.getItem("timeTravelSavedData"));
    if (savedData) {
      setRetirementYear(savedData.year);
      setPersonAge(savedData.age);
      setEstimatedVal(savedData.potValue);
      setEstimatedValue(savedData.potValue);
    }
  }, []);

  const setCounter = () => {
    setCount(1);
  };

  useEffect(() => {
    if (investorId) {
      if (!data || Object.keys(data).length === 0) {
        getHomePageContent(investorId);
      }
      if (!potData || Object.keys(potData).length === 0) {
        getTotalPotInfo(investorId);
      }
      getNotifications(investorId);
      if (!alertData || Object.keys(alertData).length === 0) {
        homeAlertContent(investorId);
      }
    }
    window.scrollTo(0, 0);
  }, [investorId]);
  useEffect(() => {
    if (investorId) {
      getYourGoals(investorId);
    }
  }, []);
  // prettier-ignore
  useEffect(() => {
    const savedData = JSON.parse(sessionStorage.getItem("timeTravelSavedData"));
    const dob = new Date(data?.timeTravel?.birthDate);
    dob.setMonth(dob.getMonth() - 1);
    const mAge =
      !dob.toString().includes("Invalid Date") &&
      calculateDecimalAge(dob.toISOString().split("T")[0]);
    if (
      calculateAge(data?.timeTravel?.birthDate) >
      parseInt(investorObject?.retirementAge)
    ) { 
      setInitialRetirementYear(
        new Date(
          new Date().setFullYear(new Date().getFullYear())
        ).getUTCFullYear()
      );
      setInitialpersonAge(calculateAge(data?.timeTravel?.birthDate));
      setRetirementYear(
        savedData
          ? savedData.year
          :
        new Date(
          new Date().setFullYear(new Date().getFullYear())
        ).getUTCFullYear()
      );
      setPersonAge(savedData ? savedData.age : calculateAge(data?.timeTravel?.birthDate));
      //Calculate Pot Value
      const payload = {
        investorId: investorObject?.investorId,
        investorAccountId: investorObject?.accountId,
        currentFundValue: totalFund,
        dateOfBirth: data?.timeTravel?.birthDate,
        annualSalary: investorObject?.employmentList?.find(
          (employee) => employee.isRecentActive
        )?.salary,
        retirementAge: parseInt(calculateAge(data?.timeTravel?.birthDate)),
        retirementDate: new Date(
          new Date().setFullYear(new Date().getFullYear())
        ).toISOString()
        .split("T")[0],
        memberAge: mAge,
      };
      if(payload?.dateOfBirth != undefined && !isNaN(payload?.memberAge)){
        calculatePotValue(payload, investorObject?.investorId, false);
      }
    } else {
      const payload = {
        investorId: investorObject?.investorId,
        investorAccountId: investorObject?.accountId,
        currentFundValue: totalFund,
        dateOfBirth: data?.timeTravel?.birthDate,
        annualSalary: investorObject?.employmentList?.find(
          (employee) => employee.isRecentActive
        )?.salary,
        retirementAge: parseInt(age),
        retirementDate: year,
        memberAge: mAge
      };
      if(payload?.dateOfBirth != undefined && !isNaN(payload?.memberAge)){
        calculatePotValue(payload, investorObject?.investorId, false);
      }
    }
  }, [accountDetailsForSavings, data]);

  // prettier-ignore
  useEffect(() => {
    const savedData = JSON.parse(sessionStorage.getItem("timeTravelSavedData"));
      if(calculatePotData?.estFundValueAtPreRetirement !== undefined){
        setEstimatedValue(savedData?.potValue ? savedData?.potValue : parseFloat(calculatePotData?.estFundValueAtPreRetirement));
        setEstimatedVal(savedData?.potValue ? savedData?.potValue : parseFloat(calculatePotData?.estFundValueAtPreRetirement));
      }else {
        setEstimatedValue(data?.timeTravel?.estimatedValue);
        setEstimatedVal(data?.timeTravel?.estimatedValue);
      }
  }, [calculatePotData]);

  useEffect(() => {
    if (count === 0) {
      setInitialEstimatedVal(estimatedValue);
    }
    setEstimatedVal(estimatedValue);
  }, [estimatedValue]);

  const displayGreeting = () => {
    const myDate = new Date();
    let greet;

    //Check if BST is in effect
    const isBST = (date) => {
      const bstStart = new Date(date.getFullYear(), 2, 31); //Last sunday in march
      bstStart.setDate(31 - bstStart.getDay());

      const bstEnd = new Date(date.getFullYear(), 9, 31); // Last sunday in october
      bstEnd.setDate(31 - bstEnd.getDay());

      return date >= bstStart && date < bstEnd;
    };

    const correctDateTime = myDate.toLocaleString("en-GB", {
      timeZone: isBST(myDate) ? "Europe/London" : "GMT",
    });
    var fullTime = correctDateTime.split(",")[1];
    var exactTime = fullTime.split(":")[0];
    if (exactTime < 12) {
      greet = DISPLAYGREETING.GOOD_MORNING;
    } else if (exactTime >= 12 && exactTime <= 17) {
      greet = DISPLAYGREETING.GOOD_AFTERNOON;
    } else if (exactTime >= 17 && exactTime <= 24) {
      greet = DISPLAYGREETING.GOOD_EVENING;
    }
    return greet;
  };

  function moreThanOnePot() {
    if (!potData?.data) return 0;

    const { savingPots, drawdownPots, dbPension } = potData.data;

    const savingsCount = savingPots?.savings?.length || 0;
    const drawdownCount = drawdownPots?.drawdown?.length || 0;
    const dbPensionCount = dbPension ? 1 : 0;

    return savingsCount + drawdownCount + dbPensionCount;
  }

  function showModal(modalName) {
    if (modalName === "PotsBreakDown") {
      if (moreThanOnePot() > 1) {
        setPopup("PotsBreakDown");
        setModalShow(true);
      } else {
        setModalShow(false);
        navigate("/savings?tab=summary");
      }
    } else {
      setPopup(modalName);
      setModalShow(true);
    }
  }
  function badgeCount() {
    const count =
      parseInt(
        notificationData?.notifications?.messageCount === null
          ? 0
          : notificationData?.notifications?.messageCount, //eslint-disable-line
      ) +
      parseInt(
        notificationData?.notifications?.documentCount === null
          ? 0
          : notificationData?.notifications?.documentCount, //eslint-disable-line
      );
    props.getBadgeCount(count);
    return count;
  }
  //Boost your savings rule
  const boostyourSavingsRule =
    (memberType && memberType.toUpperCase() === MEMBERTYPE.ACTIVE_SAVINGS) ||
    (memberType &&
      memberType.toUpperCase() === MEMBERTYPE.ACTIVE_SAVINGS_DRAWDOWN) ||
    memberType.toUpperCase() === MEMBERTYPE.DEFERRED_SAVINGS_DRAWDOWN ||
    (memberType && memberType.toUpperCase() === MEMBERTYPE.DEFERRED_SAVINGS);

  const cardCarouselRule =
    (memberType && memberType.toUpperCase() === MEMBERTYPE.ACTIVE_PENSIONER) ||
    (memberType &&
      memberType.toUpperCase() === MEMBERTYPE.DEFERRED_PENSIONER) ||
    (memberType &&
      memberType.toUpperCase() === MEMBERTYPE.ACTIVE_SAVINGS_DRAWDOWN) ||
    (memberType &&
      memberType.toUpperCase() === MEMBERTYPE.DEFERRED_SAVINGS_DRAWDOWN);

  const carouselData = [];
  const isNotPensionerDrawdown =
    memberType !== MEMBERTYPE.PENSIONER_DRAWDOWN &&
    memberType !== MEMBERTYPE.DEPENDENT_PENSIONER_DRAWDOWN;
  const cardCarouselData = [
    {
      content: (
        <Row className="card-row">
          <Col lg={6} md={6} xl={6} sm={6}>
            {memberType !== MEMBERTYPE.INACTIVE && (
              <RegularPayments
                regularPaymentsData={data && data.regularPayments}
              />
            )}
          </Col>
          <Col lg={6} md={6} xl={6} sm={6}>
            {memberType !== MEMBERTYPE.INACTIVE && isNotPensionerDrawdown && (
              <TimeTravel
                handleTellMeMore={showModal}
                timetravel={data}
                investorObject={investorObject}
                totalFund={totalFund}
                investorId={investorId}
                memberType={memberType}
                estimatedValue={estimatedValue}
                calculatePotFetching={calculatePotFetching}
                handleSave={handleSave}
                retirementYear={retirementYear}
                personAge={personAge}
                estimatedVal={estimatedVal}
                initialRetirementYear={initialRetirementYear}
                initialpersonAge={initialpersonAge}
                initialEstimatedVal={initialEstimatedVal}
                setCounter={setCounter}
              />
            )}
          </Col>
        </Row>
      ),
    },
    {
      content: (
        <Row className="card-row">
          <Col lg={6} md={6} xl={6} sm={6}>
            {memberType !== MEMBERTYPE.INACTIVE && isNotPensionerDrawdown && (
              <TimeTravel
                handleTellMeMore={showModal}
                timetravel={data}
                investorObject={investorObject}
                totalFund={totalFund}
                investorId={investorId}
                memberType={memberType}
                estimatedValue={estimatedValue}
                calculatePotFetching={calculatePotFetching}
                handleSave={handleSave}
                retirementYear={retirementYear}
                personAge={personAge}
                estimatedVal={estimatedVal}
                initialRetirementYear={initialRetirementYear}
                initialpersonAge={initialpersonAge}
                initialEstimatedVal={initialEstimatedVal}
                setCounter={setCounter}
              />
            )}
          </Col>
          <Col lg={6} md={6} xl={6} sm={6}>
            {memberType !== MEMBERTYPE.INACTIVE && (
              <YourGoals
                investorId={investorId}
                goalsFetching={goalsFetching}
                goalsData={goalsData}
                selectedGoal={selectedGoal}
                isTaskUpdated={isTaskUpdated}
                updatedTask={updatedTask}
                RadioBtnComp={<RadioBtnComp />}
                postLoading={postLoading}
                showToaster={showToaster}
              />
            )}
          </Col>
        </Row>
      ),
    },
    {
      content: memberType !== MEMBERTYPE.INACTIVE && (
        <Row className="card-row">
          <Col lg={6} md={6} xl={6} sm={6}>
            <YourGoals
              investorId={investorId}
              goalsFetching={goalsFetching}
              goalsData={goalsData}
              selectedGoal={selectedGoal}
              isTaskUpdated={isTaskUpdated}
              updatedTask={updatedTask}
              RadioBtnComp={<RadioBtnComp />}
              postLoading={postLoading}
              showToaster={showToaster}
            />
          </Col>
          <Col lg={6} md={6} xl={6} sm={6}>
            {memberType !== MEMBERTYPE.INACTIVE && (
              <RegularPayments
                regularPaymentsData={data && data.regularPayments}
              />
            )}
          </Col>
        </Row>
      ),
    },
  ];
  const mobileCardCarouselData = [
    {
      content: memberType !== MEMBERTYPE.INACTIVE && (
        <RegularPayments regularPaymentsData={data && data.regularPayments} />
      ),
    },
    {
      content: memberType !== MEMBERTYPE.INACTIVE && isNotPensionerDrawdown && (
        <TimeTravel
          handleTellMeMore={showModal}
          timetravel={data}
          investorObject={investorObject}
          totalFund={totalFund}
          investorId={investorId}
          memberType={memberType}
          estimatedValue={estimatedValue}
          calculatePotFetching={calculatePotFetching}
          handleSave={handleSave}
          retirementYear={retirementYear}
          personAge={personAge}
          estimatedVal={estimatedVal}
          initialRetirementYear={initialRetirementYear}
          initialpersonAge={initialpersonAge}
          initialEstimatedVal={initialEstimatedVal}
          setCounter={setCounter}
        />
      ),
    },
    {
      content: memberType !== MEMBERTYPE.INACTIVE && (
        <>
          <YourGoals
            investorId={investorId}
            goalsFetching={goalsFetching}
            goalsData={goalsData}
            selectedGoal={selectedGoal}
            isTaskUpdated={isTaskUpdated}
            updatedTask={updatedTask}
            RadioBtnComp={<RadioBtnComp />}
            postLoading={postLoading}
            showToaster={showToaster}
          />
        </>
      ),
    },
  ];
  if (fetching || loading || alertFetching) {
    return <LoadingSpinner />;
  }

  const alert = alertData?.properties?.broadcastMessages;
  let today = new Date();
  let segment = goalsData?.memberSegments;

  const broadcastMessages = [];
  alert?.items?.forEach(
    (item) => {
      const broadcastDate = new Date(
        item?.content?.properties?.broadcastMessageExpirationDate, //eslint-disable-line
      );
      if (broadcastDate > today) {
        broadcastMessages.push(item);
      }
    }, //eslint-disable-line
  );
  let messages = [];
  alertData?.properties?.segmentedMessages?.items?.forEach((elem) => {
    elem?.content?.properties?.segmentedMessageMemberSegment?.forEach(
      (element) => {
        if (segment?.includes(element)) {
          if (!messages.includes(elem)) {
            messages.push(elem);
          }
        }
      }, //eslint-disable-line
    );
  });
  const segmentedMessages = [];
  messages.forEach(
    (item) => {
      const segmentedDate = new Date(
        item?.content?.properties?.segmentedMessageExpirationDate, //eslint-disable-line
      );
      if (segmentedDate > today) {
        segmentedMessages.push(item);
      }
    }, //eslint-disable-line
  );

  props?.homeData?.properties?.articleCarousel.items?.forEach((elem) => {
    elem?.content?.properties?.memberSegment?.forEach(
      (element) => {
        if (segment?.includes(element)) {
          if (!carouselData.includes(elem)) {
            carouselData.push(elem);
          }
        }
      }, //eslint-disable-line
    );
  });
  let CarouselData = [];
  if (carouselData.length >= 5) {
    CarouselData = carouselData.slice(0, 5);
  } else {
    CarouselData = carouselData;
  }
  const clicked = (index) => {
    const updatedClosedBroadcast = [...closedBroadcast, index];
    setClosedBroadcast(updatedClosedBroadcast);
    localStorage.setItem(
      "closedBroadcast",
      JSON.stringify(updatedClosedBroadcast), //eslint-disable-line
    );
  };
  const MessagesClicked = () => {
    setMessagesClosed(true);
  };
  return (
    <>
      {error || err ? (
        <>
          <NotFound err={error || err} />
        </>
      ) : alertError || alertError ? (
        <>
          <NotFound err={alertError || alertError} />
        </>
      ) : (
        <Container fluid>
          <Row className="mb-4">
            <Col xs={12} sm={12} md={12} lg={12} className="mt-3">
              {showMessage &&
                broadcastMessages.map((item, index) => {
                  if (!closedBroadcast.includes(index)) {
                    return (
                      <div className="alert-msg" key={index}>
                        <Col
                          className="alert-content"
                          xs={11}
                          sm={11}
                          md={11}
                          lg={11}
                        >
                          {/* TODO - If info icon require then enable */}
                          <span className="alert-span">
                            <Icons
                              iconname="tool-tip"
                              variant="icon-eighteen-px me-2"
                            />
                          </span>
                          <span
                            className="alert-text"
                            dangerouslySetInnerHTML={{
                              __html:
                                item?.content?.properties?.broadcastMessage
                                  ?.markup,
                            }}
                          />
                        </Col>
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div className="align-right">
                            <Icons
                              iconname="close"
                              variant="icon-twenty-px me-2 mb-1"
                              clickHandler={() => clicked(index)}
                            />{" "}
                          </div>
                        </Col>
                      </div>
                    );
                  }
                })}
              <div className="name-salutation">
                {displayGreeting()}, {data && data.givenNames}
              </div>
              <Row>
                {" "}
                <Col xl={6} lg={6} sm={12} xs={12}>
                  {!MessagesClosed ? (
                    (notificationData?.notifications &&
                      notificationData?.notifications?.messageCount) ||
                    (notificationData?.notifications &&
                      notificationData?.notifications?.documentCount) ? (
                      <div className="message-document-section">
                        <Icons
                          iconname="messages"
                          variant="icon-twenty-four-px"
                          badgeCount={badgeCount()}
                        />{" "}
                        <span className="content">
                          You have{" "}
                          <Link
                            to="messages-and-documents?tab=messages"
                            aria-label={`${data.messageCount} new ${
                              data.messageCount > 1 ? "messages" : "message"
                            }`}
                            rel="noreferrer"
                          >
                            {notificationData?.notifications?.messageCount
                              ? `${
                                  notificationData?.notifications?.messageCount
                                } new ${
                                  notificationData?.notifications
                                    ?.messageCount > 1
                                    ? "messages"
                                    : "message"
                                }`
                              : ""}
                          </Link>
                          {notificationData?.notifications?.messageCount
                            ? `${
                                notificationData?.notifications?.documentCount
                                  ? " and "
                                  : ""
                              }`
                            : ""}
                          <Link
                            to="messages-and-documents?tab=documents"
                            aria-label={`${data.documentCount} new ${
                              data.messageCount > 1 ? "documents" : "document"
                            }`}
                            rel="noreferrer"
                          >
                            {notificationData?.notifications?.documentCount
                              ? `${
                                  notificationData?.notifications?.documentCount
                                } new ${
                                  notificationData?.notifications
                                    ?.documentCount > 1
                                    ? "documents"
                                    : "document"
                                }`
                              : ""}
                          </Link>
                        </span>
                        <span className="ms-2">
                          <Icons
                            iconname="close"
                            variant="icon-twenty-px"
                            clickHandler={MessagesClicked}
                          />
                        </span>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Toasts
                    floatEnd="float-end"
                    showToast={showToaster}
                    setShowToaster={setShowToaster}
                    toastContent="Well done! You have completed another goal."
                  />
                </Col>
              </Row>
            </Col>
            <div>
              <Col className="mt-4">
                <Carousel
                  messages={segmentedMessages}
                  type="broadcast-carousel"
                  interval={3000}
                  segment={segment}
                />
              </Col>
            </div>
          </Row>
          <Row className="mb-4">
            <Col xs={12} md={12} sm={12} lg={12} xl={4} xxl={6}>
              <PotValue potValue={data} />
              <div className="breadown-btn d-block d-sm-block d-md-block d-lg-block d-xl-none mb-4 mt-4">
                {memberType !== MEMBERTYPE.INACTIVE ? (
                  <Buttons
                    name="About your TPT pot"
                    className="primary"
                    iconname={isHovered ? "arrow-right" : "arrow-right-white"}
                    handleClick={handleAboutYourTPT}
                    variantname="icon-sixteen-px"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onBlur={handleOnBlur}
                  ></Buttons>
                ) : (
                  ""
                )}
              </div>
              <div className="booster-btn d-block d-lg-block d-xl-none mt-4">
                {boostyourSavingsRule ? (
                  <>
                    <Icons iconname="boost" variant="icon-thirty-two-px" />

                    <Buttons
                      name="Boost your savings - planning tool"
                      className="tertiary"
                      handleClick={() => navigate("/manage/boost-your-savings")}
                    ></Buttons>
                  </>
                ) : (
                  ""
                )}
              </div>
            </Col>
            <Row className="db-online-btn d-block d-lg-block d-xl-none mb-4">
              <Col>
                <HybridMemberLink
                  membershipType={membershipType}
                  btnName="Go to DB Online"
                />
              </Col>
            </Row>
            {/* TODO - remove inUat when TPT asks ACTIVE_SAVINGS_DRAWDOWN/ DEFERRED_SAVINGS_DRAWDOWN customers  */}
            {!inUat && cardCarouselRule ? (
              <>
                {/* Desktop */}
                <Col
                  xs={12}
                  md={12}
                  sm={12}
                  lg={12}
                  xl={8}
                  xxl={6}
                  className="card-carousel d-none d-sm-block d-md-block d-lg-block d-xl-block"
                >
                  <Carousel
                    cardCarouselData={cardCarouselData}
                    type="Card Carousel"
                    interval={null}
                  />
                </Col>
                {/* Mobile */}
                <Col
                  xs={12}
                  md={6}
                  sm={6}
                  lg={6}
                  xl={8}
                  xxl={3}
                  className="card-carousel d-md-none d-sm-none d-lg-none"
                >
                  <Carousel
                    cardCarouselData={mobileCardCarouselData}
                    type="Card Carousel"
                    interval={null}
                  />
                </Col>
              </>
            ) : (
              <>
                {!inUat &&
                memberType &&
                memberType.toUpperCase() !== MEMBERTYPE.INACTIVE &&
                (memberType.toUpperCase() === MEMBERTYPE.PENSIONER ||
                  memberType.toUpperCase() === MEMBERTYPE.DEPENDENT_PENSIONER ||
                  memberType.toUpperCase() === MEMBERTYPE.PENSIONER_DRAWDOWN ||
                  memberType.toUpperCase() ===
                    MEMBERTYPE.DEPENDENT_PENSIONER_DRAWDOWN) ? (
                  <Col xs={12} md={6} sm={6} lg={6} xl={4} xxl={3}>
                    <RegularPayments
                      regularPaymentsData={data && data.regularPayments}
                    />
                  </Col>
                ) : (
                  memberType !== MEMBERTYPE.INACTIVE &&
                  isNotPensionerDrawdown && (
                    <Col xs={12} md={6} sm={6} lg={6} xl={4} xxl={3}>
                      <TimeTravel
                        handleTellMeMore={showModal}
                        timetravel={data}
                        investorObject={investorObject}
                        totalFund={totalFund}
                        investorId={investorId}
                        memberType={memberType}
                        estimatedValue={estimatedValue}
                        calculatePotFetching={calculatePotFetching}
                        handleSave={handleSave}
                        retirementYear={retirementYear}
                        personAge={personAge}
                        estimatedVal={estimatedVal}
                        initialRetirementYear={initialRetirementYear}
                        initialpersonAge={initialpersonAge}
                        initialEstimatedVal={initialEstimatedVal}
                        setCounter={setCounter}
                      />
                    </Col>
                  )
                )}
                <Col xs={12} md={6} sm={6} lg={6} xl={4} xxl={3}>
                  {memberType !== MEMBERTYPE.INACTIVE && (
                    <YourGoals
                      investorId={investorId}
                      goalsFetching={goalsFetching}
                      goalsData={goalsData}
                      selectedGoal={selectedGoal}
                      isTaskUpdated={isTaskUpdated}
                      updatedTask={updatedTask}
                      RadioBtnComp={<RadioBtnComp />}
                      postLoading={postLoading}
                      showToaster={showToaster}
                    />
                  )}
                </Col>
              </>
            )}
          </Row>
          <Row></Row>
          <Row className="mt-2 mb-4">
            <Col
              xs={12}
              md={12}
              sm={12}
              lg={12}
              xl={4}
              xxl={6}
              className="d-none d-md-none d-lg-none d-xl-block"
            >
              <div className="breadown-btn">
                {memberType !== MEMBERTYPE.INACTIVE ? (
                  <Buttons
                    name="About your TPT pot"
                    className="primary border"
                    iconname={isHovered ? "arrow-right" : "arrow-right-white"}
                    handleClick={handleAboutYourTPT}
                    variantname="icon-sixteen-px"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onBlur={handleOnBlur}
                  ></Buttons>
                ) : (
                  ""
                )}
              </div>
              <div className="booster-btn mt-4">
                {boostyourSavingsRule ? (
                  <>
                    <Icons iconname="boost" variant="icon-thirty-two-px" />

                    <Buttons
                      name="Boost your savings - planning tool"
                      className="tertiary"
                      handleClick={() => navigate("/manage/boost-your-savings")}
                    ></Buttons>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="db-online-btn mt-4">
                <HybridMemberLink
                  membershipType={membershipType}
                  btnName="Go to DB Online"
                />
              </div>
            </Col>
            {CarouselData?.items?.length <= 0 ? (
              <Col
                xs={12}
                md={12}
                sm={12}
                lg={12}
                xl={6}
                xxl={6}
                className={cardCarouselRule ? "mt-3" : ""}
              >
                <Articles />
              </Col>
            ) : (
              <Col
                xs={12}
                md={12}
                sm={12}
                lg={12}
                xl={8}
                xxl={6}
                className={
                  cardCarouselRule
                    ? "mt-4 mb-3 article-carousel"
                    : "article-carousel "
                }
              >
                <Carousel
                  type="ArticleCarousel"
                  articleCarouselData={CarouselData}
                  interval={5000}
                />
              </Col>
            )}
          </Row>
        </Container>
      )}
      <ModalOverlay
        popup={popup}
        show={modalShow}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setModalShow(false);
        }}
        potData={potData}
        investorId={investorId}
        asOfDate={data?.pot}
        modalTitle="How much do you need to live on?"
        description="TPT supports the Pensions UK Retirement Living Standards. Based on independent research they help you to picture what kind of lifestyle you could have in retirement. "
      />
    </>
  );
};
export default Home;
